/**************************************************
 * Nombre:
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {ButtonBase, Grid2, Typography} from "@mui/material";
import {theme} from "../../../../Tema";
import {irUrl} from "../../../../Utilidades/irUrl";
import {irPDF} from "../../../../Utilidades/irPDF";

const Tarjeta_Documentacion_Informacion = ({item}) => {

    return (
        <Grid2
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            spacing={2}
            size={12}
            sx={{backgroundColor: 'white', p: 6, borderRadius: 6}}
        >

            <Grid2 container size={12}>
                <Typography sx={{
                    fontSize: 32,
                    fontWeight: 800,
                    lineHeight: 1.1,
                    display: '-webkit-box',
                    overflow: 'hidden',
                    WebkitBoxOrient: 'vertical',
                    WebkitLineClamp: 2,
                    textOverflow: "ellipsis",
                }}>
                    {item.titulo}
                </Typography>
            </Grid2>

            <Grid2 container size={12}>
                <Typography sx={{
                    fontSize: 18,
                    lineHeight: 1.4,
                    display: '-webkit-box',
                    overflow: 'hidden',
                    WebkitBoxOrient: 'vertical',
                    WebkitLineClamp: 7,
                    textOverflow: "ellipsis",
                }}>
                    {item.parrafo}
                </Typography>
            </Grid2>

            <Grid2 container size={12}>

                <ButtonBase
                    //href={item.link}
                    onClick={() => irPDF(item.link)}
                    sx={{backgroundColor: theme.palette.primary.main, borderRadius: 10, mt: 4}}>
                    <Typography

                        sx={{fontSize: 20, px: 10, py: 0.5, fontWeight: 600}}>
                        Ver
                    </Typography>
                </ButtonBase>

            </Grid2>

        </Grid2>
    )

}
export default Tarjeta_Documentacion_Informacion